import { useSearchParams } from "react-router-dom";
import AskVida from "../AskVida";

const VidaRoute = () => {
  const [searchParams] = useSearchParams();

  const conversation = searchParams.get("conversation");
  return <AskVida key={conversation ?? "new"} />;
};

export default VidaRoute;
